import {createAsyncThunk, createSelector, createSlice} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import AppUtil from "../../utilities/AppUtil";

// Main URL Endpoint
const _prefix = "/language";

export const fetchLanguagePaging = createAsyncThunk(
    "language/fetchLanguagePaging",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/page`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params),
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchLanguageDetail = createAsyncThunk(
    "language/fetchLanguageDetail",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/detail/${params}`,
            method: "GET",
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceCreateLanguage = createAsyncThunk(
    "language/reduceCreateLanguage",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}`,
            method: "POST",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.create.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceUpdateLanguage = createAsyncThunk(
    "language/reduceUpdateLanguage",
    async (data) => {
        const result = await httpRequest({
            url: `${_prefix}/update/${data.id}`,
            method: "PUT",
            data: AppUtil.toSnakeCaseKey(data.params),
            successMessage: 'toast.update.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceDeleteLanguage = createAsyncThunk(
    "language/reduceDeleteLanguage",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/delete`,
            method: "DELETE",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.remove.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);


const initialState = {
    list: [],
    detail: {}
};

const slice = createSlice({
    name: "language",
    initialState: initialState,
    reducers: {
    },
    extraReducers: {
        [fetchLanguagePaging.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.list = payload.content;
            }
        },
        [fetchLanguageDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.detail = payload;
            }
        }
    }
});

const { reducer } = slice;
export default reducer;

export const getLanguagePagingList = createSelector(
    state => state.language.list,
    list => list
)

export const getLanguageDetail = createSelector(
    state => state.language.detail,
    detail => detail
)
